var formatPartNumber = function formatPartNumber() {
  var partNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var sku = partNumber.toString();

  if (/^\d{7}$/g.test(sku)) {
    return "".concat(sku.substr(0, 3), "/").concat(sku.substr(3));
  }

  return sku;
};

export default formatPartNumber;